import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

function StructureImage({ path, title }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const mountedRef = useRef(null);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      if (mountedRef.current) setImageLoaded(true);
    };
    img.src = path;

    if (!img.complete) {
      setImageLoaded(false);
    }
  }, [path]);

  return imageLoaded ? <img className="structure" src={path} alt={title} /> : <SimpleSpinner />;
}

StructureImage.propTypes = {
  path: PropTypes.string,
  title: PropTypes.string,
};

export default StructureImage;
